import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import tooltipStyles from "features/shared/components/tooltip/tooltip.module.scss";

type Props = {
  type: "electricity" | "gas"
}

const ReservedCapacityInfoTooltip = ({ type }: Props) => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;
  const translationText = tLabels(`reservedCapacityInfoTooltip.${type}`);

  // render
  if (translationText !== "") {
    return (
      <OverlayTrigger
          placement="auto"
          overlay={
            <Tooltip id="reserved-capacity-info-tooltip-id" className={tooltipStyles.tooltip}>
              <div
                dangerouslySetInnerHTML={{ __html: translationText }}
              />
            </Tooltip>
          }
          trigger="click"
          rootClose
        >
          <span className="text-secondary ml-2">
            <FontAwesomeIcon 
              icon="info-circle"
              size="lg"
            />
          </span>
        </OverlayTrigger>
    )
  } else {
    return <></>
  }
}

export default ReservedCapacityInfoTooltip;